/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EventQuotationsBuyBody from "components/EventComponents/EventDetailsComponents/EventQuotationsBuy/EventQuotationsBuyBody/EventQuotationsBuyBody";

const EventQuotationsBuy = () => {
  useEffect(() => {
    document.title = "Event Quotations Buy";
  }, []);

  return (
    <>
      <main id="app">
        {/* ---- header start ---- */}
        <Header moduleName="events" />
        {/* --- header end --- */}
        <EventQuotationsBuyBody />
      </main>
    </>
  );
};

export default EventQuotationsBuy;
